import React, { useEffect } from 'react';
import './Navbar.css';
import { initGoogleTranslateA11y } from '../utilities/googleTranslateA11y';


const SecondaryNavbar = () => {

  useEffect(() => {
    // Label Google Translate's language picker for SR users (WCAG 2.5.3 — the
    // aria-label keeps the visible "Select Language" text so voice control
    // still matches).
    const labelTranslateLink = () => {
      const link = document.querySelector(
        '#google_translate_element a[aria-haspopup="true"]'
      );
      if (link && !link.getAttribute('aria-label')) {
        link.setAttribute(
          'aria-label',
          'Select Language to translate this page'
        );
        return true;
      }
      return Boolean(link);
    };

    // Google injects the link asynchronously, so observe — but only the
    // small #google_translate_element subtree.
    let observer;
    if (!labelTranslateLink()) {
      const container = document.getElementById('google_translate_element');
      if (container) {
        observer = new MutationObserver(() => {
          if (labelTranslateLink()) observer.disconnect();
        });
        observer.observe(container, { childList: true, subtree: true });
      }
    }

    // Google's translation-feedback flow appends <form id="goog-gt-votingForm">
    // directly to <body> with 5 unlabeled <input>s — WAVE flags them all as
    // "Missing form label" (WCAG 3.3.2). We watch <body>'s direct children
    // only, so this observer fires rarely (modal/toast appends) and never on the
    // deep DOM churn. We use `title` because WAVE counts a
    // non-empty title as a valid label (it does not count aria-label).
    const VOTING_INPUT_TITLES = {
      'goog-gt-votingInputSrcLang': 'Translation source language (Google)',
      'goog-gt-votingInputTrgLang': 'Translation target language (Google)',
      'goog-gt-votingInputSrcText': 'Translation source text (Google)',
      'goog-gt-votingInputTrgText': 'Translated text (Google)',
      'goog-gt-votingInputVote': 'Translation feedback vote (Google)',
    };
    const labelGoogleVotingInputs = () => {
      let labeledAll = true;
      for (const [id, title] of Object.entries(VOTING_INPUT_TITLES)) {
        const input = document.getElementById(id);
        if (input) {
          if (!input.getAttribute('title')) input.setAttribute('title', title);
        } else {
          labeledAll = false;
        }
      }
      return labeledAll;
    };

    let bodyObserver;
    if (!labelGoogleVotingInputs()) {
      bodyObserver = new MutationObserver(() => {
        if (labelGoogleVotingInputs()) bodyObserver.disconnect();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: false });
    }

    if (!document.getElementById('google-translate-script')) {
      const googleTranslateScript = document.createElement('script');
      googleTranslateScript.type = 'text/javascript';
      googleTranslateScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      googleTranslateScript.id = 'google-translate-script';
      window.googleTranslateElementInit = function() {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'en',
            includedLanguages: 'en,es,fr',
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          'google_translate_element'
        );
      };
      document.body.appendChild(googleTranslateScript);
    }

    const cleanupA11y = initGoogleTranslateA11y();

    return () => {
      if (observer) observer.disconnect();
      if (bodyObserver) bodyObserver.disconnect();
      if (cleanupA11y) cleanupA11y();
    };
  }, []);

  // aria-label on <nav> disambiguates this nav from the primary <Navbar /> for Screen Reader landmarks.
  return (
    <nav
      className="navbar secondNavbar navbar-expand navbar-light"
      style={{ backgroundColor: '#F26B3F', height: '1.875rem' }}
      aria-label="Secondary navigation"
    >
      <div className="container-fluid justify-content-end">
        <div id="google_translate_element" style={{ marginRight: '10px' }}></div>
        {/* Black on #F26B3F passes WCAG AA contrast (~6.88:1). Previous gray (#6c757d) was ~2.5:1 — failed. */}
        <a
          href="tel:+18008009588"
          className="navbar-text"
          style={{ color: '#000', fontWeight: 600, textDecoration: 'none' }}
          aria-label="Call SRI Services toll-free at 800-800-9588"
        >
          800.800.9588
        </a>
      </div>
    </nav>
  );
};

export default SecondaryNavbar;
